import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { ParsedUrlQuery } from 'next-runtime/types/querystring';

import { ErrorViewModel } from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';
import { paramsToObject } from '@components/views/utils';

import SeturForm, { SeturLoginData } from '../components/Form/SeturForm';
import { LoginFormData } from './LoginForm';
import { ErrorMessageGate, ErrorMessageWrapperGate } from './styled';

const LoginForm = dynamic(() => import('./LoginForm'));

const LoginGate = ({
  hasFacebookLogin,
  onPasswordReset,
  errorMessages,
  isPostLoginLoading,
  onSubmit,
  isSeturEmployee,
  onSubmitEmail,
  loginGateEmail,
  isSuccess,
  isHideLoader,
  ssoMailError,
}: {
  hasFacebookLogin?: boolean;
  onSubmit: (formData: LoginFormData) => void;
  onPasswordReset: () => void;
  errorMessages?: ErrorViewModel[];
  isPostLoginLoading?: boolean;
  isSeturEmployee: boolean;
  onSubmitEmail: (data: SeturLoginData) => void;
  loginGateEmail: string;
  isSuccess?: boolean;
  isHideLoader?: boolean;
  ssoMailError: string;
}) => {
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = paramsToObject(searchParams?.entries());

  return (
    <>
      {isSeturEmployee ? (
        <>
          {query.status === 'failed' ? (
            <>
              <ErrorMessageWrapperGate>
                <CustomIcon
                  icon={InfoIcon}
                  paletteColor='coral'
                  fontSize={15}
                />

                <ErrorMessageGate>Giriş Yapılamadı</ErrorMessageGate>
              </ErrorMessageWrapperGate>
            </>
          ) : null}
          <SeturForm
            isPostLoginLoading={isPostLoginLoading}
            onSubmitEmail={onSubmitEmail}
            isSuccess={isSuccess}
          />
          {ssoMailError ? (
            <>
              <ErrorMessageWrapperGate>
                <CustomIcon
                  icon={InfoIcon}
                  paletteColor='coral'
                  fontSize={15}
                />

                <ErrorMessageGate>{ssoMailError}</ErrorMessageGate>
              </ErrorMessageWrapperGate>
            </>
          ) : null}
        </>
      ) : (
        <LoginForm
          isHideLoader={isHideLoader}
          isSuccess={isSuccess}
          loginGateEmail={loginGateEmail}
          hasFacebookLogin={hasFacebookLogin}
          onSubmit={onSubmit}
          onPasswordReset={onPasswordReset}
          errorMessages={errorMessages}
          isPostLoginLoading={isPostLoginLoading}
        />
      )}
    </>
  );
};

export default LoginGate;
